/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const TaskLogLabelsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "logCount": zod.number()
}).strict()
export const TaskLogLabelsListResponse = zod.array(TaskLogLabelsListResponseItem)

export const taskLogLabelsCreateBodyNameMax = 40;



export const TaskLogLabelsCreateBody = zod.object({
  "name": zod.string().min(1).max(taskLogLabelsCreateBodyNameMax),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).optional().describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal')
})

export const TaskLogLabelsCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "logCount": zod.number()
}).strict()
export const TaskLogLabelsCreateResponse = zod.array(TaskLogLabelsCreateResponseItem)

export const TaskLogLabelsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the label.')
})

export const taskLogLabelsPartialUpdateBodyNameMax = 40;



export const TaskLogLabelsPartialUpdateBody = zod.object({
  "name": zod.string().min(1).max(taskLogLabelsPartialUpdateBodyNameMax).optional(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).optional().describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal')
})

export const TaskLogLabelsPartialUpdateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "logCount": zod.number()
}).strict()
export const TaskLogLabelsPartialUpdateResponse = zod.array(TaskLogLabelsPartialUpdateResponseItem)

/**
 * Past updates keep the label; it only drops out of the picker.
 */
export const TaskLogLabelsArchiveCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the label.')
})

export const TaskLogLabelsArchiveCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "logCount": zod.number()
}).strict()
export const TaskLogLabelsArchiveCreateResponse = zod.array(TaskLogLabelsArchiveCreateResponseItem)

export const TaskLogLabelsReorderCreateBody = zod.object({
  "ids": zod.array(zod.string().uuid())
})

export const TaskLogLabelsReorderCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "logCount": zod.number()
}).strict()
export const TaskLogLabelsReorderCreateResponse = zod.array(TaskLogLabelsReorderCreateResponseItem)

